import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, watchEffect, } from 'vue';
import CardSection from '@/components/Common/CardSection.vue';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import { barogoHQLatLng } from '@/constants/global';
const zoomLevel = 19;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectedAddressMap',
    setup(__props) {
        const pRequestMap = pStore.piniaRequestMap;
        let naver = null;
        let mapInstance = null;
        /** 고정마커: 선택한 주소의 좌표 마커 */
        let fixedMk = null;
        /** 좌표변경마커: 변경할 좌표 마커 */
        let newPositionMk = null;
        const { formData, } = storeToRefs(pRequestMap);
        /**
         * 고정 마커 업데이트
         */
        const updateFixedMk = () => {
            const { latitude, longitude, } = pRequestMap.getterLatlong;
            if (!mapInstance) {
                console.log('[updatePosition] mapInstance 없음');
                return;
            }
            // 지도 이동
            mapInstance.updateBy(new naver.maps.LatLng(latitude, longitude), zoomLevel);
            // 고정 마커 있으면 업데이트
            if (fixedMk) {
                fixedMk.setPosition(new naver.maps.LatLng(latitude, longitude));
                // 없으면 생성
            }
            else {
                fixedMk = new naver.maps.Marker({
                    map: mapInstance,
                    position: new naver.maps.LatLng(latitude, longitude),
                });
            }
        };
        /**
         * 고정 마커 제거
         */
        const deleteFixedMk = () => {
            if (fixedMk) {
                fixedMk.setMap(null);
                fixedMk = null;
            }
        };
        /**
         * 뉴포지션 마커 제거
         */
        const deleteNewPositionMk = () => {
            if (newPositionMk) {
                newPositionMk.setMap(null);
                newPositionMk = null;
            }
        };
        /**
         * 네이버 지도 api 다이나믹 import
         * cypress 등에선 naver가 최초에 없기 때문에 따로 처리해줘야 함
         */
        const importNaverMap = async () => {
            if (window.naver) {
                return;
            }
            const URL = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${process.env.VUE_APP_NAVER_CLIENT_ID}`;
            const script = document.createElement('script');
            if (script) {
                script.setAttribute('src', URL);
                script.id = 'naver-map-load';
                document.head.appendChild(script);
            }
        };
        /**
         * 지도 신규 위치 생성 이벤트 핸들러
         */
        const handleClickMapInstance = (event) => {
            // 좌표 켜지 않거나
            // 선택한 항목 없으면 불가
            if (!formData.value.isChangePosition
                || !formData.value.selectedAddress) {
                return;
            }
            const point = event.coord;
            // 마커 있으면 업데이트
            if (newPositionMk) {
                newPositionMk.setPosition(point);
                // 없으면 생성
            }
            else {
                newPositionMk = new naver.maps.Marker({
                    map: mapInstance,
                    position: point,
                    icon: {
                        url: '/svg/map-control/drop-delay-default.svg',
                    },
                });
            }
            formData.value.newPosition = {
                latitude: String(point._lat),
                longitude: String(point._lng),
            };
        };
        /**
         * 이벤트 초기화
         */
        const initEvent = () => {
            naver.maps.Event.addListener(mapInstance, 'click', handleClickMapInstance);
        };
        /**
         * 네이버 지도 실행
         */
        const initNaverMap = () => {
            naver = window.naver;
            const center = barogoHQLatLng;
            const initialZoom = 10;
            const mapOptions = {
                center: new naver.maps.LatLng(center[0], center[1]),
                zoom: initialZoom,
                mapDataControl: false,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    position: naver.maps.Position.TOP_LEFT,
                },
                scaleControl: true,
                scaleControlOptions: {
                    position: naver.maps.Position.BOTTOM_RIGHT,
                },
                zoomControl: true,
                zoomControlOptions: {
                    style: naver.maps.ZoomControlStyle.SMALL,
                    position: naver.maps.Position.RIGHT_TOP,
                },
                logoControlOptions: {
                    position: naver.maps.Position.LEFT_BOTTOM,
                },
            };
            mapInstance = new naver.maps.Map('naver-map', mapOptions);
            initEvent();
        };
        /**
         * 네이버 지도 호출
         */
        const onLoadNaverMap = () => {
            if (window.naver) {
                initNaverMap();
            }
            else {
                document
                    .getElementById('naver-map-load')
                    // eslint-disable-next-line no-return-assign
                    .onload = () => window.naver.maps.onJSContentLoaded = initNaverMap;
            }
        };
        onMounted(() => {
            onLoadNaverMap();
        });
        // onCreated
        importNaverMap();
        watchEffect(() => {
            if (!formData.value.isChangePosition
                || !formData.value.newPosition) {
                deleteNewPositionMk();
            }
        });
        pRequestMap.$onAction(({ name }) => {
            if (name !== 'publishUpdateMapPosition') {
                return;
            }
            if (formData.value.selectedAddress) {
                updateFixedMk();
            }
            else {
                deleteFixedMk();
            }
        });
        return (_ctx, _cache) => {
            const _component_v_switch = _resolveComponent("v-switch");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(CardSection, {
                    class: "naver-map-wrapper",
                    p0: "",
                    "unset-height": ""
                }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createElementVNode("div", { id: "naver-map" }, [
                            _createCommentVNode(" 네이버 지도 ")
                        ], -1 /* CACHED */)
                    ])),
                    _: 1 /* STABLE */,
                    __: [1]
                }),
                _createElementVNode("div", null, [
                    _createVNode(_component_v_switch, {
                        modelValue: _unref(formData).isChangePosition,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(formData).isChangePosition) = $event)),
                        class: "brg-switch",
                        color: "primary",
                        disabled: !_unref(formData).selectedAddress,
                        label: _unref(formData).isChangePosition ? '좌표 변경 ON (지도에 변경할 위치를 클릭하세요.)' : '좌표 변경 OFF',
                        "hide-details": "",
                        density: "compact"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled", "label"]),
                    _createCommentVNode(" 아래 코멘트는 좌표 변경한다고 할 때만 출력 "),
                    _createCommentVNode(" * 지도에서 좌표를 클릭해 주세요 ")
                ])
            ]));
        };
    }
});
